import React from "react";
import { PieLabelRenderProps } from "recharts";

interface ResponsivePieLabelProps extends PieLabelRenderProps {
  chartWidth: number;
}

const ResponsivePieLabel: React.FC<ResponsivePieLabelProps> = ({
  cx,
  cy,
  midAngle,
  outerRadius,
  percent = 0,
  name = "",
  fill = "#000",
  chartWidth,
}) => {
  const RADIAN = Math.PI / 180;

  // Valores numéricos
  const cxNum = Number(cx ?? 0);
  const cyNum = Number(cy ?? 0);
  const angleNum = Number(midAngle ?? 0);
  const radiusNum = Number(outerRadius ?? 0);

  // 🔹 MÁS DISTANCIA → más espacio visual
  const labelRadius = radiusNum * 1.65;

  // 🔹 Mejor tamaño de fuente
  const fontSize =
    chartWidth < 340 ? 11 : chartWidth < 450 ? 12 : 13;

  // Posiciones originales
  let x = cxNum + labelRadius * Math.cos(-angleNum * RADIAN);
  let y = cyNum + labelRadius * Math.sin(-angleNum * RADIAN);

  // =============================
  // 🧠 ANTI-SOLAPAMIENTO SUAVE
  // =============================
  // Afinamos la altura para separar textos cercanos
  const verticalSpread = radiusNum * 0.05;
  y += Math.sin(-angleNum * RADIAN) * verticalSpread;

  // =============================
  // 🧱 LIMITAR QUE SE SALGA
  // =============================
  const margin = 20;
  x = Math.max(margin, Math.min(x, chartWidth - margin));

  return (
    <text
      x={x}
      y={y}
      fill={fill}
      fontSize={fontSize}
      textAnchor="middle"
      dominantBaseline="central"
      style={{
        whiteSpace: "nowrap",
        pointerEvents: "none",
        fontWeight: 500,
      }}
    >
      {`${name}: ${(percent * 100).toFixed(0)}%`}
    </text>
  );
};

export default ResponsivePieLabel;
